<template>
    <a class="wrap-back-top" id="to-top-btn" href="javascript:scrollTo(0,0);"></a>
</template>

<script>
    export default {
        data(){
            return {

            }
        },
        methods:{
            scrollToTop(el) {
            　　let topBtn = document.getElementById('to-top-btn');
                  let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                  let browserHeight = window.outerHeight;
                  if (scrollTop > browserHeight) {
                        topBtn.style.display = 'block';
                  } else {
                        topBtn.style.display = 'none';
                  }
            }
        },
        mounted () {
          window.addEventListener('scroll', this.scrollToTop)
        },
        destroyed () {
            window.removeEventListener('scroll', this.scrollToTop);
        }
    }
</script>

<style lang="less" rel="stylesheet">
    .wrap-back-top{
        position:fixed;
        bottom:.3rem;
        right:.3rem;
        display:none;
        width:.8rem;
        height:.8rem;
        background:rgba(0,0,0,.2) url("../assets/imgs/back_top_icon.png") no-repeat center center;
        box-shadow:0 0 10px rgba(255,255,255,.1);
        border-radius:100%;
    }
</style>